import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { MoreVertIcon } from "../images/MoreVertIcon";
import { StyledMenu } from "../ui";
import { CRMRequestModal } from "../products/CreateCampaignFlow/steps/TargetAccountsStep/CRMRequestModal";

enum MenuModals {
  resend = "resend",
  cancel = "cancel",
  none = "none",
}

type Props = {
  currentEmail: string;

  cancelHandler: () => void;
  resendHandler: (email: string) => void;
  isLoading: boolean;
  isMenuOpen: boolean;
};

export const ResyncMarketoMenu = ({
  currentEmail,
  cancelHandler,
  resendHandler,
  isLoading,
  isMenuOpen,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openModal, setOpenModal] = useState<MenuModals>(MenuModals.none);
  const [currentFlow, setCurrentFlow] = useState<string>("");

  useEffect(() => {
    if (currentFlow) {
      setCurrentFlow("");
    }
  }, [currentFlow]);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onCloseHandler = () => {
    setOpenModal(MenuModals.none);
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!isMenuOpen) onCloseHandler();
  }, [isMenuOpen]);

  const setEmailHandler = (email: string) => {
    email === "" ? cancelHandler() : resendHandler(email);
  };

  const options = [
    {
      label: "Send Request Again",
      onClick: () => setOpenModal(MenuModals.resend),
    },
    {
      label: "Cancel Request",
      onClick: () => setOpenModal(MenuModals.cancel),
    },
  ];

  const modal: Record<MenuModals, ReactNode> = {
    [MenuModals.resend]: (
      <CRMRequestModal
        currentEmail={currentEmail}
        setCurrentEmail={(email) => setEmailHandler(email)}
        onClose={onCloseHandler}
        isLoading={isLoading}
        modalType={"resend"}
        crmType="Marketo"
      />
    ),
    [MenuModals.cancel]: (
      <CRMRequestModal
        currentEmail={currentEmail}
        setCurrentEmail={() => setEmailHandler("")}
        onClose={onCloseHandler}
        isLoading={isLoading}
        modalType={"cancel"}
        crmType="Marketo"
      />
    ),
    [MenuModals.none]: null,
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon width="24" />
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
          },
        }}
      >
        {options.map(({ label, onClick }) => (
          <MenuItem
            key={label}
            sx={{
              display: "flex",
              gap: "12px",
              alignItems: "center",
            }}
            onClick={onClick}
          >
            {label}
          </MenuItem>
        ))}
      </StyledMenu>

      {modal[openModal]}
    </div>
  );
};
